import { Component, Input } from '@angular/core';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';

@Component({
  selector: 'app-small-notification',
  standalone: true,
  imports: [ZenithComponentsModule],
  templateUrl: './small-notification.component.html',
  styleUrl: './small-notification.component.scss',
})
export class SmallNotificationComponent {

  @Input() znIconName: string;
  @Input() label: string;

}
